import { Component, Host, h, Prop, Listen, State } from '@stencil/core';
import { isPlatform } from '@baloise/ds-core';

@Component({
  tag: 'bam-interferer',
  styleUrl: 'bam-interferer.scss',
  shadow: false,
})
export class BamInterferer {
  @Prop() isCompact?: boolean;
  @Prop() color?: 'green' | 'purple' | 'red' | 'yellow';
  @Prop() isImage?: boolean | undefined;
  @Prop() reducedMarginBottom?: boolean | undefined;

  @State() isTouch: boolean;

  @Listen('resize', { target: 'window' })
  handleResize() {
    this.setIsTouch();
  }

  setIsTouch() {
    this.isTouch = isPlatform(window, 'touch');
  }

  connectedCallback() {
    this.setIsTouch();
  }

  render() {
    return (
      <Host
        class={{
          'bam-interferer': true,
          'fullwidth': true,
          'custom-margin-bottom': !this.reducedMarginBottom || this.isTouch,
          'bam-interferer--is-compact': this.isCompact,
          'bam-interferer--is-image': this.isImage,
          [`bam-interferer--is-${this.color}`]: this.color && !this.isImage,
        }}
      >
        {!this.isImage && <slot name="content"></slot>}
        {this.isImage && (
          <div class="bam-interferer__image-wrapper">
            <slot name="image"></slot>
          </div>
        )}
      </Host>
    );
  }
}
